import { DialogActions, DialogContent, FormGroup, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";
import BaseCheckbox from "../../../common/base-checkbox/base-checkbox";
import BaseDialog from "../../../common/base-dialog/base-dialog";

function Category({ open, setOpen, replaceList, replaceFilterList, handleChangeCheckBox }) {
    //general variables
    const { t } = useTranslation();

    const submitFilter = () => {
        setOpen(false);
    };

    return (
        <Grid container item xs={12} display={{ xs: "flex", md: "none" }}>
            <BaseDialog title={t("category")} open={open} handleClose={() => setOpen(false)} top="40%" icon="back">
                <DialogContent dividers={true}>
                    <FormGroup>
                        {replaceFilterList.map(filter => {
                            return (
                                <BaseCheckbox
                                    key={filter?.id}
                                    label={filter?.label}
                                    name={filter?.name}
                                    checked={filter?.checked}
                                    handleChange={handleChangeCheckBox}
                                    disabled={replaceList?.length === 1 && replaceList.find(item => item.category === "free")}
                                />
                            );
                        })}
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Grid container item xs={10} mx="auto">
                        <BaseButton text={t("update")} color="secondary" size="medium" radius="radius-10" handleClick={submitFilter} />
                    </Grid>
                </DialogActions>
            </BaseDialog>
        </Grid>
    );
}

export default Category;
